import { BookingKitEventType } from "@bonliva-crm/shared";

export enum MainFilterType {
  Comment = BookingKitEventType.Comment,
  SystemLog = BookingKitEventType.SystemLog
}

export type FilterType = `${MainFilterType}`;
